export default {
  MOBILE: "mobile",
  TABLET: "tablet",
  DESKTOP: "desktop",
};
